<template>
  <div class="product-info-wrapper">
    <div class="banner">
      <div class="cover cover-zhsqglpt">
        <div class="cover-text">
          <h4>物联网智慧社区平台</h4>
          <p class="info">是一个基于物联网、大数据、边缘计算等技术架构，面向政府基层单位搭建的市域治理数字孪生城市实战平台。能够实现街镇、社区治理数据的科学汇聚、分析、决策。</p>
        </div>
      </div>
    </div>
    <!-- 产品功能 -->
    <div class="product-function">
      <div class="common-title">
        <div class="common-title-content">
          产品功能
        </div>
      </div>
      <div class="product-function-list">
        <div class="item" v-for="(item, index) in funcList" :key="index">
          <img :src="item.imgUrl" />
          <div class="text">{{ item.text }}</div>
        </div>
      </div>
    </div>
    <!-- 产品优势 -->
    <div class="product-advantage product-advantage-blue bg2F61AE">
      <div class="common-title">
        <div class="common-title-content">
          产品优势
        </div>
      </div>
      <div class="content content-blue">
        <div class="circle">
          <div class="badge">
            <img src="@/assets/images/productInfo/zhsqglpt/badge.png" />
          </div>
          <div class="feature feature-one">
            <div class="text">可视化时空大地图</div>
          </div>
          <div class="feature feature-two">
            <div class="text">多维算法实时预警</div>
          </div>
          <div class="feature feature-three">
            <div class="text">生态打通整合</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 应用场景 -->
    <div class="product-application-scene">
      <div class="common-title">
        <div class="common-title-content">
          应用场景
        </div>
      </div>
      <div class="product-scene-list">
        <div class="item" v-for="(item, index) in sceneList" :key="index">
          <img :src="item.imgUrl" />
          <div class="text" v-html="item.text"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "zhsqglpt",
  data() {
    return {
      funcList: [
        {
          imgUrl: require("@/assets/images/productInfo/zhsqglpt/ico_sjzt.png"),
          text: "数据专题"
        },
        {
          imgUrl: require("@/assets/images/productInfo/zhsqglpt/ico_ypfx.png"),
          text: "研判分析"
        },
        {
          imgUrl: require("@/assets/images/productInfo/zhsqglpt/ico_zhcx.png"),
          text: "综合查询"
        },
        {
          imgUrl: require("@/assets/images/productInfo/zhsqglpt/ico_xggl.png"),
          text: "巡更管理"
        },
        {
          imgUrl: require("@/assets/images/productInfo/zhsqglpt/ico_ycfy.png"),
          text: "异常反应"
        }
      ],
      sceneList: [
        {
          imgUrl: require("@/assets/images/productInfo/zhsqglpt/zdfwbq.png"),
          text: "重点房屋标签"
        },
        {
          imgUrl: require("@/assets/images/productInfo/zhsqglpt/zdrybq.png"),
          text: "重点人员标签"
        },
        {
          imgUrl: require("@/assets/images/productInfo/zhsqglpt/qzfwjg.png"),
          text: "群租房屋监管"
        },
        {
          imgUrl: require("@/assets/images/productInfo/zhsqglpt/lrqtkh.png"),
          text: "老人群体看护"
        }
      ]
    };
  }
};
</script>
